import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import RangeDatePicker from '@/components/RangeDatePicker/RangeDatePicker';
import SelectField from '@/components/SelectField';

import { DownloadOrdersProps } from '../../Table/useOrderStatus';
import useDownloadModal from './useDownloadModal';

export interface IDownloadModal {
  downloadOrders: (ars: DownloadOrdersProps) => void;
}

const DownloadModal = ({ downloadOrders }: IDownloadModal) => {
  const hook = useDownloadModal({ downloadOrders });
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="subtitle2" mb={2}>
        Elige las fechas en donde están las órdenes
      </Typography>
      <RangeDatePicker
        untilToday
        disablePortal={false}
        startLabel="Desde"
        endLabel="Hasta"
        onChange={(e, v) => {
          if (e === 'startDate') {
            hook.setDates({ ...hook.dates, createdAtStart: v });
          }
          if (e === 'endDate') {
            hook.setDates({ ...hook.dates, createdAtEnd: v });
          }
        }}
      />
      <SelectField
        label="Selecciona el tipo de reporte"
        options={hook.availableTypes}
        value={hook.reportType}
        onChange={(e: React.ChangeEvent<{ value: string }>) => {
          hook.handleReportType(e);
        }}
        name="reportType"
        sxLabel={{ ...theme.typography.subtitle2, color: theme.palette.secondary.main }}
      />
      {hook.reportType === 'orders_list' && (
        <Box>
          <Typography variant="subtitle2" mt={2} mb={1}>
            Selecciona los estados
          </Typography>
          <FormGroup row>
            {hook.fulfillmentStatusOptions.map((option) => (
              <FormControlLabel
                control={
                  <Checkbox
                    name={option.value}
                    checked={hook.fulfillmentStatus.includes(option.value)}
                    onChange={hook.handleFulfillmentStatus}
                  />
                }
                label={option.label}
              />
            ))}
          </FormGroup>
        </Box>
      )}
      <Button
        sx={{ mt: '2rem', alignSelf: 'flex-end' }}
        onClick={hook.download}
        disabled={hook.isDisabled}
      >
        Descargar órdenes
      </Button>
    </Box>
  );
};

export default DownloadModal;
